module.exports = __webpack_public_path__ + "dafb7090af243588bf45751f57353f74.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/animals/fox.svg
// module id = 87
// module chunks = 0